module.exports = __webpack_public_path__ + "img/png7.daec54b0.png";